import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import ListingLoadMore from '../../listing/js/ListingLoadMore';

export default class QualifiedPlayersListingLoadMore extends React.PureComponent {
    render() {
        return ReactDOM.createPortal(
            <ListingLoadMore {...this.props} />,
            this.props.loadMoreElement,
        );
    }
}


QualifiedPlayersListingLoadMore.propTypes = {
    loadMoreElement: PropTypes.instanceOf(Element).isRequired,
};
